import { render, staticRenderFns } from "./Bom.vue?vue&type=template&id=c032a176&scoped=true&"
import script from "./Bom.vue?vue&type=script&lang=js&"
export * from "./Bom.vue?vue&type=script&lang=js&"
import style0 from "./Bom.vue?vue&type=style&index=0&id=c032a176&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c032a176",
  null
  
)

export default component.exports